module.exports = __webpack_public_path__ + "static/img/0000智慧校园2.d505a05.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000智慧校园2.jpg
// module id = hHNH
// module chunks = 0